<button type="button" mat-icon-button (click)="back()" matTooltip="Zurück">
  <mat-icon>arrow_back</mat-icon>
</button>
